import { render, staticRenderFns } from "./AccusedList.vue?vue&type=template&id=08d53f24"
import script from "./AccusedList.vue?vue&type=script&lang=js"
export * from "./AccusedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports